skrilla.controller('voidEventMarketSelectionsModalCtrl', function ($scope, searchService, modalService, cacheService) {
    $scope.bettingEvent = cacheService.getObjectOrElse("bettingEvent", function(){modalService.dismissAll()});
    $scope.endTime = new Date()

    $scope.voidSelections = function(){
        modalService.confirm("Are you sure you'd like to void selections this event's market?", function(){
            searchService.post("betting/events/" + $scope.bettingEvent.eventId + "/voidSelections",  {message: $scope.message, endTime: $scope.endTime}, "Bet selections successfully voided").then(function(response){
                modalService.dismissAll();
                $scope.get()
            });
        });
    }
});
